import React from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { fetchSites } from '../../actions/SiteActions'
import SiteContainer from '../../components/layout/SiteContainer'
import ContainerHeading from '../../components/layout/ContainerHeading'
import HelmetTitle from '../../components/layout/HelmetTitle'
import LoadingScreen from '../../components/LoadingScreen'
import { GridContainer, GridSection, Column, ListHeaderRow, ListRow, ColumnStyle, SmallScreenSiteDataColumnStyle, SmallScreenSiteDataSiteName, SmallScreenSiteDataDetail, ActionHeaderColumnStyle, ActionColumnStyle, ActionColumnStyleRightAligned, ActionIconContainer } from './styled-elements'
import styledTheme from '../../styles/theme'
import ArrowRightBoldCircle from '../../components/icons/ArrowRightBoldCircle'
import Moment from 'moment-timezone'

class Sites extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      layoutWidth: this.getLayoutWdth()
    }
  }

  getLayoutWdth = () => {
    if (typeof window === 'undefined') return styledTheme.breakpoints.lg
    return window.innerWidth
  }

  resizeHandler = (e) => {
    if (e.target.innerWidth===this.state.layoutWidth) return
    this.setState({ layoutWidth: this.getLayoutWdth() })
  }

  componentDidMount() {
    const { dispatch } = this.props
    dispatch(fetchSites())
    window.addEventListener('resize', this.resizeHandler)
  }

  componentDidUpdate() {
  }

  formatTime(timeInt,timezone) {
    const currentTimeInt = parseInt(new Date().getTime()/1000,10)
    const diffSecs = currentTimeInt-timeInt
    if (diffSecs < 60) {
      return `${diffSecs} seconds ago`
    } else if (diffSecs < 3600) {
      return `${parseInt(diffSecs/60,10)} minutes ago`
    } else if (diffSecs < 7200) {
      return `1 hour ago`
    } else if (diffSecs < 86400) {
      return `${parseInt(diffSecs/3600,10)} hours ago`
    } else if (diffSecs < 172800) {
      return `1 day ago`
    } else if (diffSecs < 8640000) {
      return `${parseInt(diffSecs/86400,10)} days ago`
    } else {
      return Moment(timeInt*1000).format('DD MMM YYYY HH:mm')
    }
  }

  routeToDataViews = (site) => {
    this.props.dispatch(push(`/sites/${site.company_slug}/${site.slug}`))
  }

  isMobileView = () => {
    const screenWidth = window.innerWidth
    return (screenWidth < styledTheme.breakpoints.md)
  }

  renderSitesHeaderRow = (parentCompanyView) => <ListHeaderRow key={0}>
    { parentCompanyView && <Column xs={3} style={ColumnStyle}>Company Name</Column> }
    <Column xs={parentCompanyView ? 4 : 5} style={ColumnStyle}>Site Name</Column>
    <Column xs={parentCompanyView ? 2 : 3} style={ColumnStyle}>Data Last Updated</Column>
    <Column xs={parentCompanyView ? 2 : 3} style={ColumnStyle}>Data Samples</Column>
    <Column xs={1} style={ActionHeaderColumnStyle}>View</Column>
  </ListHeaderRow>

  renderSmallScreenSiteRows = (sites,parentCompanyView) => sites.map((site,index) => <ListRow key={index+1} onClick={this.routeToDataViews.bind(this,site)}>
    <Column xs={10} style={SmallScreenSiteDataColumnStyle}>
        <SmallScreenSiteDataSiteName>{site.name}</SmallScreenSiteDataSiteName>
        { parentCompanyView && <SmallScreenSiteDataDetail>{site.company_name }</SmallScreenSiteDataDetail> }
        <SmallScreenSiteDataDetail>{site.data_last_retrieved_at ? `Last updated ${this.formatTime(site.data_last_retrieved_at, site.timezone_name)}` : 'No data retrieved yet'}</SmallScreenSiteDataDetail>
        <SmallScreenSiteDataDetail>{site.data_samples_count} readings</SmallScreenSiteDataDetail>
    </Column>
    <Column xs={2} style={ActionColumnStyleRightAligned}><ActionIconContainer onClick={this.routeToDataViews.bind(this,site)}><ArrowRightBoldCircle /></ActionIconContainer></Column>
  </ListRow>)

  renderLargeScreenSiteRows = (sites,parentCompanyView) => sites.map((site,index) => <ListRow key={index+1} onClick={this.routeToDataViews.bind(this,site)}>
    { parentCompanyView && <Column xs={3} style={ColumnStyle}>{site.company_name}</Column> }
    <Column xs={parentCompanyView ? 4 : 5} style={ColumnStyle}>{site.name}</Column>
    <Column xs={parentCompanyView ? 2 : 3} style={ColumnStyle}>{site.data_last_retrieved_at ? this.formatTime(site.data_last_retrieved_at, site.timezone_name) : ''}</Column>
    <Column xs={parentCompanyView ? 2 : 3} style={ColumnStyle}>{site.data_samples_count}</Column>
    <Column xs={1} style={ActionColumnStyle}><ActionIconContainer onClick={this.routeToDataViews.bind(this,site)}><ArrowRightBoldCircle /></ActionIconContainer></Column>
  </ListRow>)

  renderSites(sites) {
    const parentCompanyView = true
    const isMobileView = this.isMobileView()
    if (sites.sites) {
      return <GridContainer>
        <ContainerHeading title={`Sites`} />
        <GridSection>
          { isMobileView && this.renderSmallScreenSiteRows(sites.sites,parentCompanyView) }
          { !isMobileView && this.renderSitesHeaderRow(parentCompanyView) }
          { !isMobileView && this.renderLargeScreenSiteRows(sites.sites,parentCompanyView) }
        </GridSection>
      </GridContainer>
    }
  }

  renderBody = (props,state) => <div>
    <LoadingScreen show={(props.sites.fetching && !props.sites.sites.length)}/>
    {props.sites && this.renderSites(props.sites)}
  </div>

  render = () => <SiteContainer>
    <HelmetTitle title={`Sites`} />
    {this.renderBody(this.props,this.state)}
  </SiteContainer>

}

export default connect(
  (store, props) => ({
    sites: store.sites,
  }),
)(Sites)




// WEBPACK FOOTER //
// ./src/containers/sites/index.js